import React from "react";
import Article from "./Article";
import Image from "./Image";
import HtmlInteractive from "./HtmlInteractive";
import Audio from "./Audio";
import Video from "./Video";
import Pmbok from "./Pmbok";
import MultiMedia from "./MultiMedia";
import RotaryCard from "./RotaryCard";

const CardSwitcher = ({
  post,
  lookup,
  showPmbokModal,
  showShareModal,
  showFeedbackModal,
  cardFilterSelected,
  canProceed,
  isAuthenticated,
  playlists,
  feedbackSentContentKeys,
  fullcard,
  propGroup,
  userLikes,
  feedbacks,
  contentKey,
  id,
}) => {
  const card = () => {
    if (!post) {
      return (
        <div className="text-center">
          <i className="fas fa-spin fa-spinner mr-3" />
          Loading Post...
        </div>
      );
    }

    switch (post.contentType) {
      case "CTArticleWText":
      case "CTArticleWInterview":
      case "CTCaseStudyText":
      case "CTTemplate":
      case "CTAudioTextTranscript":
      case "CTVideoTextTranscript":
        return (
          <Article
            post={post}
            lookup={lookup}
            showPmbokModal={showPmbokModal}
            showShareModal={showShareModal}
            showFeedbackModal={showFeedbackModal}
            cardFilterSelected={cardFilterSelected}
            canProceed={canProceed}
            isAuthenticated={isAuthenticated}
            playlists={playlists}
            feedbackSentContentKeys={feedbackSentContentKeys}
            fullcard={fullcard}
            propGroup={propGroup}
            userLikes={userLikes}
            feedbacks={feedbacks}
            contentKey={contentKey}
            id={id}
          />
        );
      case "CTRotaryGraphic":
        return (
          <RotaryCard
            post={post}
            lookup={lookup}
            showPmbokModal={showPmbokModal}
            showShareModal={showShareModal}
            showFeedbackModal={showFeedbackModal}
            cardFilterSelected={cardFilterSelected}
            canProceed={canProceed}
            isAuthenticated={isAuthenticated}
            playlists={playlists}
            feedbackSentContentKeys={feedbackSentContentKeys}
            fullcard={fullcard}
            propGroup={propGroup}
            userLikes={userLikes}
            feedbacks={feedbacks}
            contentKey={contentKey}
            id={id}
          />
        );
      case "CTGraphicNoText":
        return (
          <Image
            post={post}
            lookup={lookup}
            showPmbokModal={showPmbokModal}
            showShareModal={showShareModal}
            showFeedbackModal={showFeedbackModal}
            cardFilterSelected={cardFilterSelected}
            canProceed={canProceed}
            isAuthenticated={isAuthenticated}
            playlists={playlists}
            feedbackSentContentKeys={feedbackSentContentKeys}
            fullcard={fullcard}
            propGroup={propGroup}
            userLikes={userLikes}
            feedbacks={feedbacks}
            contentKey={contentKey}
            id={id}
          />
        );
      case "CTHtmlInteractiveGraphic":
        return (
          <HtmlInteractive
            post={post}
            lookup={lookup}
            showPmbokModal={showPmbokModal}
            showShareModal={showShareModal}
            showFeedbackModal={showFeedbackModal}
            cardFilterSelected={cardFilterSelected}
            canProceed={canProceed}
            isAuthenticated={isAuthenticated}
            playlists={playlists}
            feedbackSentContentKeys={feedbackSentContentKeys}
            fullcard={fullcard}
            propGroup={propGroup}
            userLikes={userLikes}
            feedbacks={feedbacks}
            contentKey={contentKey}
            id={id}
          />
        );
      case "CTAudio":
      case "CTArticleWInterviewAudio":
        return (
          <Audio
            post={post}
            lookup={lookup}
            showPmbokModal={showPmbokModal}
            showShareModal={showShareModal}
            showFeedbackModal={showFeedbackModal}
            cardFilterSelected={cardFilterSelected}
            canProceed={canProceed}
            isAuthenticated={isAuthenticated}
            playlists={playlists}
            feedbackSentContentKeys={feedbackSentContentKeys}
            fullcard={fullcard}
            propGroup={propGroup}
            userLikes={userLikes}
            feedbacks={feedbacks}
            contentKey={contentKey}
            id={id}
          />
        );
      case "CTVideo":
        return (
          <Video
            post={post}
            lookup={lookup}
            showPmbokModal={showPmbokModal}
            showShareModal={showShareModal}
            showFeedbackModal={showFeedbackModal}
            cardFilterSelected={cardFilterSelected}
            canProceed={canProceed}
            isAuthenticated={isAuthenticated}
            playlists={playlists}
            feedbackSentContentKeys={feedbackSentContentKeys}
            fullcard={fullcard}
            propGroup={propGroup}
            userLikes={userLikes}
            feedbacks={feedbacks}
            contentKey={contentKey}
            id={id}
          />
        );
      case "CTVerbatim":
        return (
          <Pmbok
            post={post}
            showPmbokModal={showPmbokModal}
            showShareModal={showShareModal}
            showFeedbackModal={showFeedbackModal}
            cardFilterSelected={cardFilterSelected}
            canProceed={canProceed}
            isAuthenticated={isAuthenticated}
            playlists={playlists}
            lookup={lookup}
            feedbackSentContentKeys={feedbackSentContentKeys}
            fullcard={fullcard}
            propGroup={propGroup}
            userLikes={userLikes}
            feedbacks={feedbacks}
            contentKey={contentKey}
            id={id}
          />
        );
      case "CTMultiMedia":
      case "CTArticleAudio":
      case "CTArticleVideo":
        return (
          <MultiMedia
            post={post}
            showPmbokModal={showPmbokModal}
            showShareModal={showShareModal}
            showFeedbackModal={showFeedbackModal}
            cardFilterSelected={cardFilterSelected}
            canProceed={canProceed}
            isAuthenticated={isAuthenticated}
            playlists={playlists}
            lookup={lookup}
            fullcard={fullcard}
            propGroup={propGroup}
            userLikes={userLikes}
            feedbacks={feedbacks}
            contentKey={contentKey}
            id={id}
          />
        );
      default:
        return (
          <Article
            post={post}
            lookup={lookup}
            showPmbokModal={showPmbokModal}
            showShareModal={showShareModal}
            showFeedbackModal={showFeedbackModal}
            cardFilterSelected={cardFilterSelected}
            canProceed={canProceed}
            isAuthenticated={isAuthenticated}
            playlists={playlists}
            feedbackSentContentKeys={feedbackSentContentKeys}
            fullcard={fullcard}
            propGroup={propGroup}
            userLikes={userLikes}
            feedbacks={feedbacks}
            contentKey={contentKey}
            id={id}
          />
        );
    }
  };

  return <>{card()}</>;
};

export default CardSwitcher;
